import { prop, find, propEq, } from 'ramda';

export const getClassification = (topic, classId) => find(
  propEq('_id', classId),
  prop('classifications', topic),
);
